import React, { useState, useEffect } from "react";
import "../Address.css";
import { useApiStore } from "../hooks/ApiStoreContext";
import { useNavigate } from "react-router-dom";

const AddressList = ({ onEdit, onAdd, selectOnly = false, onSelectDeliveryAddress, refreshAddresses, onSelectBillingAddress }) => {
  const [addresses, setAddresses] = useState([]);
  const apiStore = useApiStore();
  const navigate = useNavigate();

  useEffect(() => {
    let loginUserId = localStorage.getItem("geniusBabySiteUserId");
    if (!loginUserId) {
      navigate("/login");
      return;
    }
    fetchAddresses();
  }, [refreshAddresses]);

  const fetchAddresses = async () => {
    const addressList = await getAddressList();
    setAddresses(addressList);
    const defaultDeliveryAddress = addressList.find((address) => address.isDeliveryAddress);
    if (defaultDeliveryAddress) {
      if (onSelectDeliveryAddress) {
        onSelectDeliveryAddress(defaultDeliveryAddress);
      }
    }

    const defaultBillingAddress = addressList.find((address) => address.isBillingAddress);
    if (defaultBillingAddress) {
      if (onSelectBillingAddress) {
        onSelectBillingAddress(defaultBillingAddress);
      }
    }
  };

  function showLoginModal() {
    const loginModal = document.getElementById("login");
    const modal = new window.bootstrap.Modal(loginModal);
    modal.show();
  }

  const getAddressList = async () => {
    try {
      let loginUserId = localStorage.getItem("geniusBabySiteUserId");
      if (!loginUserId) {
        showLoginModal();
        return;
      }
      const response = await apiStore.get("/Address/GetAddressByUserId/" + loginUserId);
      return response;
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await apiStore.delete("/Address/" + id);
      //setAddresses(addresses.filter((address) => address.addressId !== id));
      fetchAddresses();
    } catch (error) {
      console.error(error);
      if (error && error.response && error.response.data.indexOf("orders associated") > -1) {
        alert(error.response.data);
      }
    }
  };

  const handleSetDefault = async (id, type) => {
    try {
      await apiStore.put(`/Address/default/${id}/${type}`);
      setAddresses(
        addresses.map((address) => {
          if (address.addressId === id) {
            if (type === "delivery") {
              address.isDeliveryAddress = true;
              if (selectOnly) {
                handleDeliveryAddressSelect(address);
              }
              return address;
            } else if (type === "billing") {
              address.isBillingAddress = true;
              if (selectOnly) {
                handleBillingAddressSelect(address);
              }
              return address;
            }
          } else {
            if (type === "delivery") {
              return { ...address, isDeliveryAddress: false };
            } else if (type === "billing") {
              return { ...address, isBillingAddress: false };
            }
          }
          return address;
        })
      );
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeliveryAddressSelect = (address) => {
    if (onSelectDeliveryAddress) {
      onSelectDeliveryAddress(address);
    }
  };

  const handleBillingAddressSelect = (address) => {
    if (onSelectBillingAddress) {
      onSelectBillingAddress(address);
    }
  };

  return (
    <div className="addressList">
      <button onClick={onAdd}>Add New Address</button>
      <ul className="address-list">
        {addresses.map((address) => (
          <li key={address.addressId}>
            <p>
              {address.name}
              <br />
              {address.contactPerson}
              <br />
              {address.gstNumber}
              <br />
              {address.addressLine1}
              <br />
              {address.addressLine2 && (
                <span>
                  {address.addressLine2}
                  <br />
                </span>
              )}
              {address.city} {address.zipCode}, {address.state} 
              <br />
              {address.country}
              <br />
              {address.phoneNumber}
              <br />
              {address.transport}
              <br />
              <label style={{ fontWeight: "normal", fontSize: "14px", cursor: "pointer" }}>
                <div style={{ display: "flex" }}>
                  <input type="checkbox" checked={address.isDeliveryAddress} onChange={() => handleSetDefault(address.addressId, "delivery")} style={{ marginRight: "3px" }} />
                  Use as Delivery Address
                </div>
              </label>
              <br />
              <label style={{ fontWeight: "normal", fontSize: "14px", cursor: "pointer" }}>
                <div style={{ display: "flex" }}>
                  <input type="checkbox" checked={address.isBillingAddress} onChange={() => handleSetDefault(address.addressId, "billing")} style={{ marginRight: "3px" }} />
                  Use as Billing Address
                </div>
              </label>
            </p>
            {!selectOnly && (
              <div>
                <button onClick={() => onEdit(address)}>Edit</button>
                <button onClick={() => handleDelete(address.addressId)}>Delete</button>
              </div>
            )}
            {/* {selectOnly ? (
              <div style={{ display: "flex" }}>
                <input type="radio" id={`address-${address.addressId}`} name="address" checked={selectedAddressId === address.addressId} onChange={() => handleAddressSelect(address)} style={{ marginRight: "5px", marginTop: "2px", cursor: "pointer" }} />
                <label htmlFor={`address-${address.addressId}`} style={{ cursor: "pointer" }}>
                  Select this address
                </label>
              </div>
            ) : (
              <div>
                <button onClick={() => onEdit(address)}>Edit</button>
                <button onClick={() => handleDelete(address.addressId)}>Delete</button>
              </div>
            )} */}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AddressList;
